import { hooks } from 'mage-i18n';
import React from 'react';
// @ts-ignore
import { Chip } from '@klarna/bubble-ui';
import { useHelpbotState } from '../contexts/HelpbotStateProvider';
const styles = {
    optionContainer: {
        marginBottom: '10px',
        textAlign: 'right'
    }
};
const HelpbotOption = ({ option: { value } }) => {
    const { handleAnswerForActiveStep } = useHelpbotState();
    const t = hooks.useTranslator();
    const handleOnPress = () => {
        handleAnswerForActiveStep(value);
    };
    return (React.createElement("div", { style: styles.optionContainer },
        React.createElement(Chip, { title: t(value), onPress: handleOnPress })));
};
export { HelpbotOption };
